// extracted by mini-css-extract-plugin
var _1 = "_regionBaseForm-module__button-container";
var _2 = "_regionBaseForm-module__button-subcontainer";
var _3 = "_regionBaseForm-module__container";
var _4 = "_regionBaseForm-module__form-container";
var _5 = "_regionBaseForm-module__span-2";
export { _1 as "button-container", _2 as "button-subcontainer", _3 as "container", _4 as "form-container", _5 as "span-2" }
